import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import { TrashBinIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  onClick?: () => void;
  disabled?: boolean;
};

export const DeleteConnectionsButton: FC<Props> = ({ disabled, onClick }) => {
  const { t } = useTranslation();

  return (
    <AppButton
      className={styles["delete-connections-button"]}
      onClick={onClick}
      disabled={disabled}
    >
      <TrashBinIcon />
      {t("common.deleteSelected")}
    </AppButton>
  );
};
